import { COUNTRY_CONFIG } from 'Douleutaras/constants/localization';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { LANGUAGES } from 'Douleutaras/constants/system';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { CaptureException } from 'Douleutaras/providers/CaptureException';
import LanguageSwitcherItem from 'Douleutaras/layout/partials/LanguageSwitcherItem';
import enIcon from 'Assets/layout/languageIcon/language-icon--en.svg';
import elIcon from 'Assets/layout/languageIcon/language-icon--el.svg';
import ptIcon from 'Assets/layout/languageIcon/language-icon--pt.svg';

// Map language codes to their respective icons
const LANGUAGE_ICONS: Record<string, string> = {
  en: enIcon,
  el: elIcon,
  pt: ptIcon
};

export const langCodeToLiteral = (langCode: string, t) => {
  switch (langCode) {
    case LANGUAGES.EN.CODE:
      return t('T.CD.IN.EN');
    case LANGUAGES.EN_IE.CODE:
      return t('T.CD.IN.EN-IE');
    case LANGUAGES.EN_PT.CODE:
      return t('T.CD.IN.EN-PT');
    case LANGUAGES.EL.CODE:
      return t('T.CD.IN.EL');
    case LANGUAGES.EL_CY.CODE:
      return t('T.CD.IN.EL-CY');
    case LANGUAGES.PT.CODE:
      return t('T.CD.IN.PT');
    default:
      return t('T.CD.IN.NO-LANG');
  }
};

const languageChange = (lang: string) => async () => {
  try {
    await axios.get(`${COUNTRY_CONFIG.API_URL[(useLocalization()).countryCode]}activate-language/${lang.toLowerCase()}/?no-redirect=1`, {
      method: 'GET',
      maxRedirects: 0,
      withCredentials: true
    });
    // @TODO remove this when https://gitlab.douleutaras.com/core/douleutaras/-/issues/7485 is done

    /* ATTENTION: THIS IS A HACK, IT SHOULD BE REMOVED ASAP */
    const cookieLangCode = {
      [LANGUAGES.EN.CODE]: 'en',
      [LANGUAGES.EL.CODE]: 'el',
      [LANGUAGES.EN_IE.CODE]: 'en-IE',
      [LANGUAGES.EN_PT.CODE]: 'en-PT',
      [LANGUAGES.EL_CY.CODE]: 'el-CY',
      [LANGUAGES.PT.CODE]: 'pt-PT'
    };

    Cookies.set('languagecode', cookieLangCode[lang]);
    window.location.reload();

  } catch (error) {
    CaptureException(error);
  }
};
const getLanguageIconUrl = (langCode: string) =>
  `/Assets/layout/languageIcon/language-icon--${langCode}.svg`;

const LanguageSwitcher = ({ isDropdownSwitcher }) => {
  const { t, i18n } = useTranslation();
  const { countryCode } = useLocalization();
  const [ userDropdown, setUserDropdown ]  = useState(false);
  // tslint:disable-next-line:no-null-keyword
  const dropDownRef = useRef(null);

  const dropDownClick = status => {
    setUserDropdown(status);
  };

  useEffect(() => {
    if (isDropdownSwitcher) {
      // Close dropdown when clicked from outside
      document.addEventListener('mousedown', e => {
        const element = dropDownRef.current;
        if (element !== e.target && element && !element.contains(e.target)) {
          dropDownClick(false);
        }
      });
    }
  }, []);

  return (
    <>
    { isDropdownSwitcher ?
      <>
        {COUNTRY_CONFIG.LANGUAGES_SUPPORTED[countryCode].length > 1 &&
        <div className={
          classNames({
            'homepage-switcher': true,
            opened: userDropdown
          })} ref={dropDownRef}>
          <header className="homepage-switcher-header" onClick={() => dropDownClick(!userDropdown)}>
            <div className="homepage-switcher-header__content">
              <span className="homepage-switcher-header__icon">
                <span className="homepage-switcher-item__icon-inner">
                  <img
                    src={LANGUAGE_ICONS[i18n.language]}
                    alt={`${i18n.language} icon`}
                    className="language-dropdown-item__svg"
                  />
                </span>
              </span>
              <span className="homepage-switcher-header__title">
                {langCodeToLiteral(i18n.language, t)}
              </span>
            </div>
            <span className="homepage-switcher-header__arrow"/>
          </header>
          <div className="homepage-switcher-content">
            {COUNTRY_CONFIG.LANGUAGES_SUPPORTED[countryCode].map(lang =>
              <LanguageSwitcherItem
                elementClass="homepage-switcher"
                icon={
                  <img src={LANGUAGE_ICONS[lang.toLowerCase()]} alt={`${i18n.language} icon`} className="language-dropdown-item__svg" />
                }
                text={langCodeToLiteral(lang, t)}
                onClick={languageChange(lang)}
                key={lang}
                active={(lang === i18n.language)}
              />
            )}
          </div>
        </div>
        }
      </>
    :
      <>
        {COUNTRY_CONFIG.LANGUAGES_SUPPORTED[countryCode]
          .filter(lang => lang !== i18n.language)
          .map(lang =>
            <LanguageSwitcherItem
              elementClass="language-dropdown"
              icon={
                <img src={LANGUAGE_ICONS[lang.toLowerCase()]} alt={`${i18n.language} icon`} className="language-dropdown-item__svg" />
              }
              text={langCodeToLiteral(lang, t)}
              onClick={languageChange(lang)}
              key={lang}
              active={(lang === i18n.language)}
            />
          )}
      </>
    }
    </>
  );
};

export default LanguageSwitcher;
